import { brokerApi } from "../lib/api";

// Typed adapter for the deterministic CMA engine. Mirrors the external
// FastAPI contract: /cma/preview, /cma/reports, /cma/reports/{id}, /export.
export const cmaService = {
  async preview(params) {
    const { data } = await brokerApi.get("/cma/preview", { params });
    return data;
  },
  async createReport(body) {
    const { data } = await brokerApi.post("/cma/reports", body);
    return data;
  },
  async getReport(id) {
    const { data } = await brokerApi.get(`/cma/reports/${id}`);
    return data;
  },
  async updateNotes(id, notes) {
    const { data } = await brokerApi.patch(`/cma/reports/${id}`, { notes });
    return data;
  },
  exportUrl(id) {
    return `${brokerApi.defaults.baseURL}/cma/reports/${id}/export?format=pdf`;
  },
};
